import { TextareaAutosize } from "@mui/base";
import { styled } from "@mui/material";
import { Field } from "formik";
import React from "react";
import { colors } from "theme";

const Textarea = styled(TextareaAutosize)(
  ({ customStyle }) => `
        box-sizing: border-box;
        width: 100%;
        font-family: 'Inter', sans-serif;
        font-size: ${customStyle?.fontSize || '16px'};
        font-weight: 400;
        line-height: 1.5;
        padding: ${customStyle?.padding || '12px'};
        border-radius: ${customStyle?.borderRadius || '12px 12px 0 12px'};
        resize: vertical;
        color: ${customStyle?.color || '#000'};
        border: 1px solid ${colors.primaryColor};
      `
);

function BaseTextArea({ name, customStyle }) {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <div>
          <Textarea {...field} minRows={1} customStyle={customStyle} sx={{ fontFamily: "Montserrat"}} />
          {meta.touched && meta.error && (
            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>{meta.error}</div>
          )}
        </div>
      )}
    </Field>
  );
}

export default BaseTextArea;
